import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmptyValueModule } from '@app/infrastructure/pipes/empty-value/empty-value.module';
import { ClipboardCopyModule } from '@shared/clipboard-copy/clipboard-copy.module';
import { TableComponent } from './table.component';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@NgModule({
	declarations: [TableComponent],
	imports: [
		CommonModule,
		MatTableModule,
		MatSortModule,
		MatPaginatorModule,
		ClipboardCopyModule,
		EmptyValueModule,
		TooltipModule,
	],
	exports: [TableComponent, MatTableModule, MatSortModule],
})
export class TableModule {}
